import { Chip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import ConfigAndMapDetailsTable from "./ConfigAndMapDetailsTable";

interface Props {
  familiesTitle: string;
}

const tableHeadings = {
  metric: "Metric",
  derivation: "Derivation",
};
const rows = [
  {
    metric: "ftd",
    derivation: "as delivered from unifier",
  },
  {
    metric: "qftd",
    derivation: "as delivered from unifier",
  },
  {
    metric: "cpa_income",
    derivation: "as delivered from unifier",
  },
  {
    metric: "revshare_income",
    derivation: "as delivered from unifier",
  },
  {
    metric: "net_revenue",
    derivation: "as delivered from unifier",
  },
  {
    metric: "total_income",
    derivation: "as delivered from unifier",
  },
];

const filteringColumns = [
  "%Commission",
  "CPACommission",
  "Netrevenue",
  "TotalBets/Hands",
  "brand_action_date",
  "cpacommissioncount",
  "downloads",
  "firstdepositcount",
  "purchaccount",
  "purchaccountcount",
  "totalcommission",
];

const details = [
  {
    label: "Interface",
    value: "IncomeAccess",
  },
  {
    label: "Destination Table",
    value: "daily_user_performance",
  },
];

const advisor_details = [
  {
    label: "Interface",
    value: "IncomeAccess",
  },
  {
    label: "Destination Table",
    value: "daily_brand_campaign_performance",
  },
];

const ManualConfigurationModalBodyTwo = ({ familiesTitle }: Props) => {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          maxHeight: "400px",
          overflow: "auto",
          p: 2,
        }}
      >
        {familiesTitle === "Unifier" && (
          <>
            {/* Unifier map details */}

            <Box
              width={"100%"}
              sx={{
                borderRadius: "4px",
                border: "1px dashed #BDBDBD",
                p: 1,
                py: 2,
                mb: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  color: "#00000099",
                  textAlign: "center",
                }}
              >
                Select a map to preview its details
              </Typography>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#000000DE",
                }}
              >
                ia_user_per_day_account_detailed{" "}
                <span style={{ color: "#00000099" }}>(12)</span>
              </Typography>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#00000099",
                  mb: 0.2,
                }}
              >
                Used by 5 brands
              </Typography>
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "2fr 1.8fr 5fr",
                gap: 3,
                py: 2,
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              {details.map((item) => (
                <Box key={item.label}>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#00000099",
                      mb: 0.2,
                    }}
                  >
                    {item.label}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: "#000000DE",
                    }}
                  >
                    {item.value}
                  </Typography>
                </Box>
              ))}
            </Box>
            {/* Filtering Definition */}
            <Box sx={{ mt: 2 }}>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#000000DE",
                  mb: 1,
                }}
              >
                Filtering Definition
              </Typography>

              {/* Chips */}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 0.5,
                }}
              >
                {filteringColumns.map((column) => (
                  <Chip
                    key={column}
                    label={column}
                    variant="outlined"
                    sx={{
                      height: "28px",
                      borderRadius: "16px",
                      borderColor: "#d9d9d9",
                      backgroundColor: "#fff",
                      fontSize: "14px",
                      letterSpacing: "0.17px",
                      color: "#000000DE",
                      px: 0.8,

                      "& .MuiChip-label": {
                        px: 0.2,
                      },
                    }}
                  />
                ))}
              </Box>
            </Box>
          </>
        )}

        {familiesTitle === "Advisor" && (
          <>
            {/* Advisor map details */}

            <Box
              width={"100%"}
              sx={{
                borderRadius: "4px",
                border: "1px dashed #BDBDBD",
                p: 1,
                py: 2,
                mb: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  color: "#00000099",
                  textAlign: "center",
                }}
              >
                Select a map to preview its details
              </Typography>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#000000DE",
                }}
              >
                ia_user_per_day_account_detailed{" "}
                <span style={{ color: "#00000099" }}>(12)</span>
              </Typography>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#00000099",
                  mb: 0.2,
                }}
              >
                Used by 5 brands
              </Typography>
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "2fr 1.8fr 5fr",
                gap: 3,
                py: 2,
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              {advisor_details.map((item) => (
                <Box key={item.label}>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#00000099",
                      mb: 0.2,
                    }}
                  >
                    {item.label}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: "#000000DE",
                    }}
                  >
                    {item.value}
                  </Typography>
                </Box>
              ))}
            </Box>
            <ConfigAndMapDetailsTable
              tableHeadings={tableHeadings}
              rows={rows}
            />
          </>
        )}
      </Box>
    </>
  );
};

export default ManualConfigurationModalBodyTwo;
